import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {WidgetDiscrepanciesSettings} from './widget-discrepancies-settings.model';
import {DemandPartner} from '../../../../../shared/domain/demand-partner.model';
import {BridgeAdUnit} from '../../../../../shared/domain/bridge-ad-unit.model';
import {DateRangeType} from '../../../../../shared/domain/date-range-type.enum';
import {DateRangeHolder} from '../../../../../shared/domain/date-range-holder.model';
import {ReportMetric, ReportMetricsAll} from '../../../domain/report/report-metric.enum';

@Component({
  selector: 'cm-widget-discrepancies-set-dialog',
  template: `
    <h1 mat-dialog-title>Widget settings</h1>
    <div mat-dialog-content>
      <div class="row">
        <div class="col col-auto">
          <cm-demand-partner-autocomplete-chips
            [demandPartnerIds]="settings.demandPartnerIds"
            (itemSelectionChange)="demandPartnerSelectionChange($event)">
          </cm-demand-partner-autocomplete-chips>
        </div>

        <div class="col col-auto">
          <cm-ad-unit-autocomplete-chips
            [adUnitIds]="settings.adUnitIds"
            (adUnitSelectionChange)="adUnitSelectionChange($event)">
          </cm-ad-unit-autocomplete-chips>
        </div>
        <div class="col col-auto">
          <cm-report-builder-predicates [predicates]="settings.predicates"
                                        [metrics]="metrics"></cm-report-builder-predicates>
        </div>
      </div>
      <div class="col col-auto">
          <cm-date-range-chooser [dateTo]="settings.dateTo"
                                 [dateFrom]="settings.dateFrom"
                                 [allowedDateRangeTypes]="allowedDateRangeTypes"
                                 [autoSubmitCustomDate]="true"
                                 (dateRangeChanged)="onDateRangeChanged($event)">
          </cm-date-range-chooser>
        </div>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-end">
      <button mat-button [mat-dialog-close]="settings">Save</button>
      <button mat-button color="warn" mat-dialog-close cdkFocusInitial>Cancel</button>
    </div>

  `,
})
export class WidgetDiscrepanciesSettingsDialogComponent {

  settings: WidgetDiscrepanciesSettings;

  allowedDateRangeTypes = [
    DateRangeType.YESTERDAY,
    DateRangeType.THIS_WEEK,
    DateRangeType.LAST_7_DAYS,
    DateRangeType.LAST_MONTH,
    DateRangeType.LAST_30_DAYS,
    DateRangeType.THIS_MONTH,
  ];

  metrics = ReportMetricsDiscrepancy;

  constructor(public dialogRef: MatDialogRef<WidgetDiscrepanciesSettingsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.settings = JSON.parse(JSON.stringify(data.settings));
  }

  onDateRangeChanged(date: DateRangeHolder) {
    this.settings.dateFrom = date.dateFrom;
    this.settings.dateTo = date.dateTo;
    this.settings.dateRangeType = date.dateRangeType;
  }

  demandPartnerSelectionChange($event: DemandPartner[]) {
    this.settings.demandPartnerIds = $event.map(a => a.name);
  }

  adUnitSelectionChange($event: BridgeAdUnit[]) {
    this.settings.adUnitIds = $event.map(a => a.id);
  }

}

export const ReportMetricsDiscrepancy = ReportMetricsAll().filter(metric => [
  ReportMetric.REVENUE_DISCREPANCY,
  ReportMetric.REVENUE_DISCREPANCY_AMOUNT,
  ReportMetric.AD_REQUEST_DISCREPANCY,
  ReportMetric.FILLED_DISCREPANCY,
].includes(metric.key));
